import { INACTIVE_CLIENT_STATUS } from '../constants/clientStatus';

/** @typedef {import('../entities/CareModelCohort.types').Client} Client */

/**
 * Deactivated clients take no part in cohort assignment, so they are excluded from every
 * suggestion the review flows produce.
 *
 * @param {Client} client
 * @returns {boolean}
 */
export function isClientEligibleForCohortAssignment(client) {
  return client?.status !== INACTIVE_CLIENT_STATUS;
} // isClientEligibleForCohortAssignment()

/**
 * @param {Client[]} clients
 * @returns {Client[]}
 */
export function getAssignableClients(clients = []) {
  return clients.filter(isClientEligibleForCohortAssignment);
} // getAssignableClients()
